export const ROUTES = {
  ticket: '/ticket/:ticketId/:threadId?',
  root: '/'
};